const ActionTypes = {
  SET_PROMOTION_POPUP_CONFIG: "SET_PROMOTION_POPUP_CONFIG",
  SET_PROMOTION_POPUP_VISIBILITY_STATUS:
    "SET_PROMOTION_POPUP_VISIBILITY_STATUS",
};

function setPromotionPopupConfig(preschoolRemoteConfigObj) {
  return {
    type: ActionTypes.SET_PROMOTION_POPUP_CONFIG,
    payload: preschoolRemoteConfigObj,
  };
}

function setPromotionPopupVisibilityStatus(isVisible) {
  return {
    type: ActionTypes.SET_PROMOTION_POPUP_VISIBILITY_STATUS,
    payload: isVisible,
  };
}


export { ActionTypes, setPromotionPopupConfig, setPromotionPopupVisibilityStatus };



// WEBPACK FOOTER //
// ./src/js/store/actions/promotionpopupconfig.js